export default "__VITE_ASSET__UvUUmNU8__"